import keymirror from 'keymirror';

export default keymirror({
  light: null,
  full: null,
  header: null,
});
